var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-title mb-5"},[_c('div',{staticClass:"is-flex-grow-1 title-container is-hidden-mobile"},[_c('h3',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticClass:"title is-4"})]),_c('div',{staticClass:"is-flex-shrink-0"},[_c('div',{staticClass:"buttons"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }